import { Provider } from '@angular/core';

import { PricingApiService } from './pricing-api.service';
import { PricingHttpService } from './pricing-http.service';

/** Registra la implementación de `PricingApiService` que usa la app. */
export function providePricing(): Provider[] {
  return [{ provide: PricingApiService, useClass: PricingHttpService }];
}
